/**
 * @format
 * @Description: layout请求层
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import Request from 'utils/request';
import Cookie from 'js-cookie';
import { isArray } from 'lodash';
export default class LayoutServ {
  static getAppById() {
    return Request({
      url: `api/user/v1/application/appInstance/${Cookie.get('instance_id')}`,
      method: 'get'
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/Layout/LayoutServ.js